import { collection, doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";

export const KAZA_FIELDS = ["tarih", "saat", "plaka", "personel", "personelId", "tesis", "aciklama", "kazaBasligi", "olayTuru", "isKazasi", "yapilanIs", "sonuc", "alinanOnlemler", "kazaFotoURL", "raporURL", "evraklar"];
export function changesBetween(before, after) {
  return KAZA_FIELDS.filter((field) => JSON.stringify(before[field] ?? null) !== JSON.stringify(after[field] ?? null)).map((field) => ({ field, before: before[field] ?? null, after: after[field] ?? null }));
}
export async function saveAccident({ id, values, version = 0, user }) {
  const reference = id ? doc(db, "kazalar", id) : doc(collection(db, "kazalar"));
  const history = doc(collection(db, "kazalar", reference.id, "history"));
  const savedVersion = await runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(reference);
    if (id && !snapshot.exists()) throw new Error("Kaza kaydı bulunamadı.");
    const before = snapshot.exists() ? snapshot.data() : {};
    if (id && (before.version || 0) !== version) throw new Error("Bu kayıt başka bir kullanıcı tarafından güncellendi. Sayfayı yenileyip yeniden düzenleyin.");
    const changes = changesBetween(before, values);
    if (id && !changes.length) return before.version || 0;
    const metadata = { updatedAt: serverTimestamp(), updatedBy: user.email || user.uid, version: (before.version || 0) + 1 };
    if (id) transaction.update(reference, { ...values, ...metadata });
    else transaction.set(reference, { ...values, ...metadata, createdAt: serverTimestamp(), createdBy: user.email || user.uid });
    transaction.set(history, { action: id ? "UPDATE" : "CREATE", changes, createdAt: serverTimestamp(), createdBy: user.email || user.uid, createdByUid: user.uid || "", version: metadata.version });
    return metadata.version;
  });
  return { id: reference.id, version: savedVersion };
}
